import React, { useState } from 'react';
import WorkNoteEditor from './WorkNoteEditor';

const PREVIEW_CHARS = 60;

const svgProps = {
  width: 14, height: 14, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor',
  strokeWidth: 2, strokeLinecap: 'round', strokeLinejoin: 'round', 'aria-hidden': true,
};

// Collapsed: first ~60 chars + expand icon (muted when empty).
// Expanded: full text; owner gets an editor, everyone else (admins included) read-only.
export default function WorkNoteCell({ entry, isOwner, onSave }) {
  const [expanded, setExpanded] = useState(false);
  const [editing, setEditing] = useState(false);
  const note = entry.work_note || '';
  const preview = note.length > PREVIEW_CHARS ? `${note.slice(0, PREVIEW_CHARS)}…` : note;

  if (editing && isOwner) {
    return (
      <WorkNoteEditor
        initialValue={note}
        onCancel={() => setEditing(false)}
        onSave={async (text) => { await onSave(entry.id, text); setEditing(false); }}
      />
    );
  }

  return (
    <div className="mt-1 text-sm">
      <button
        type="button"
        onClick={() => setExpanded((v) => !v)}
        title={note ? 'Show work description' : 'No work description'}
        aria-expanded={expanded}
        className={`inline-flex items-center gap-1.5 text-left ${note ? 'text-ink' : 'text-faint'}`}
      >
        <svg {...svgProps} className={`transition-transform ${expanded ? 'rotate-90' : ''}`}><path d="M9 6l6 6-6 6" /></svg>
        <svg {...svgProps}><path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z" /><path d="M14 3v5h5M9 13h6M9 17h6" /></svg>
        {note && !expanded && <span className="ml-1">{preview}</span>}
        {!note && <span className="ml-1 text-xs">no description</span>}
      </button>
      {expanded && (
        <div className="mt-1">
          {note && <p className="whitespace-pre-wrap break-words max-w-xs text-ink">{note}</p>}
          {note && entry.note_updated_by && (
            <p className="text-xs text-muted">
              {entry.note_updated_by}{entry.note_updated_at ? `, ${new Date(entry.note_updated_at).toLocaleDateString('en-GB')}` : ''}
            </p>
          )}
          {isOwner && (
            <button type="button" onClick={() => setEditing(true)}
              className="text-xs text-accent underline mt-1">
              {note ? 'Edit description' : 'Add description'}
            </button>
          )}
        </div>
      )}
    </div>
  );
}
